import $ from 'jquery'
import { useSelect } from '@wordpress/data';
const bookingStoreName = 'WPTravelFrontend/BookingData';
import { useEffect, useState } from '@wordpress/element'

export default ( ) => {
    
    if( wp_travel.stripe_new_ui == 'yes' ){
        useEffect( () => {
 
            const stripeInit = ( form ) => {
                // Create references to the main form and its submit button.
                var stripe, elements, style, card, form, submitBtn, paymentIntent, cardElement, cardEl;
                submitBtn = form.querySelector('input[type=submit]');
                cardElement = document.createElement('div')

                cardElement.classList.add('wp-travel-form-field', 'payment-card-field')
                var refElement = form.querySelector('.wp-travel-form-field.button-field')
                cardEl = refElement.parentNode.insertBefore(cardElement, refElement)

                // Create a Stripe client.
                stripe = Stripe(wp_travel.payment.stripe_publishable_key);
                elements = stripe.elements();
                style = {
                    iconStyle: 'solid',
                    style: {
                        base: {
                            iconColor: '#c4f0ff',
                            color: '#fff',
                            fontWeight: 500,
                            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                            fontSize: '16px',
                            fontSmoothing: 'antialiased',

                            ':-webkit-autofill': {
                                color: '#fce883',
                            },
                            '::placeholder': {
                                color: '#87BBFD',
                            },
                        },
                        invalid: {
                            iconColor: '#FFC7EE',
                            color: '#FFC7EE',
                        },
                    }
                };

                var form = document.getElementById('wp-travel-booking');
                const postData = {};

                const formData = new FormData(form);

                for (const [key, value] of formData.entries()) {
                    if (postData[key]) {
                    postData[key] = Array.isArray(postData[key]) ? [...postData[key], value] : [postData[key], value];
                    } else {
                    postData[key] = value;
                    }
                }
                
                    $('.wptravel-single-page-stripcheckout').css('display', 'flex');
                    $('.wptravel-single-page-stripcheckout').css('margin-bottom', '20px');
                    $('#card-element').css('border', 'none');
                    $('#card-element').css('padding', '0');
                    $('#card-element').append('<div id="loader-init"><div class="stripe-loader"></div></div><span class="btn" id="wptravel-proceed-with-stripe">Proceed Payment</span>');

                    $( "#wptravel-proceed-with-stripe" ).on( "click", function(e) {
                        var trpPrice = $('#onpage-trip_price').val();
                        $(this).css('display', 'none');
                        $('.stripe-loader').css('display', 'block');
                       
                        var data = {
                            formData: postData,
                            currency: wp_travel.payment.currency_code,
                            currency_symbol: wp_travel.currency_symbol,
                            total_qty: 1,
                            title: 'Trip Book',
                            amount: trpPrice,
                            customer_name: document.querySelector('input[name^=wp_travel_fname_traveller]') ? document.querySelector('input[name^=wp_travel_fname_traveller]').value : document.querySelector('input[name=account_first_name]').value,
                            customer_email: document.querySelector('input[name^=wp_travel_email_traveller]') ? document.querySelector('input[name^=wp_travel_email_traveller]').value : document.querySelector('input[name=account_email]').value
                        };

                        data.page = 'wptravel-single-trip';
                        fetch(wp_travel.ajaxUrl + '?action=payment_intents', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ data: data })
                        }).then(function (result) {

                            // Handle server response (see Step 3)
                            result.json().then(function (json) {
                            const clientSecret = json.payment_intent_client_secret;
                                elements = stripe.elements({ clientSecret });

                                    const paymentElementOptions = {
                                        layout: "tabs",
                                    };

                                    const paymentElement = elements.create("payment", paymentElementOptions);
                                    paymentElement.mount("#card-element");

                                    $('.wp-travel-one-page-booking-buttons').css( 'opacity', 1 );
                                    $('.wp-travel-one-page-booking-buttons').css( 'pointer-events', 'auto' );
                                    $('.wp-travel-one-page-booking-buttons').css( 'cursor', 'auto' );

                                    $('.wp-travel-one-page-booking-buttons').css('display', 'block');
                                    
                            })
                        });
                    }); 

                    $( "#wptravel-pay-with-stripe" ).on( "click", function(e) {

                        if ($("#wp-travel-partial-payment").length) {
                        console.log( 'parsley not required' )
                        } else {
                        wt_parsley = jQuery("#wp-travel-booking").parsley()

                        if (!wt_parsley.isValid()) {
                            return wt_parsley.validate();
                        }
                        }
                        
                        e.preventDefault();

                        stripe.confirmPayment({
                            elements,
                        //   redirect: 'if_required',
                            confirmParams: {
                            // Make sure to change this to your payment completion page
                            return_url: window.location.href,
                            },
                        })  
                            
                    } );
                }

                
                

                if ($('input[name="wp_travel_payment_gateway"]:checked').val() === 'stripe') {
                    $('.wptravel-single-page-stripcheckout').css( 'visibility', 'visible' );
                }else{
                    $('.wptravel-single-page-stripcheckout').css( 'visibility', 'hidden' );
                }

                let isStripeInitialized = false;

                $('input[name="wp_travel_payment_gateway"]').on('change', function () {
                    const selectedGateway = $('input[name="wp_travel_payment_gateway"]:checked').val();

                    if (selectedGateway === 'stripe' && !isStripeInitialized) {
                        $('.wptravel-single-page-stripcheckout').css('visibility', 'visible');

                        const form = document.getElementById('wp-travel-booking') || document.getElementById('wp-travel-partial-payment');
                        if (form && wp_travel.payment.stripe_publishable_key.length > 0) {
                            stripeInit(form); 
                            isStripeInitialized = true; // Set flag after initialization
                        }
                    } else if (selectedGateway !== 'stripe') {
                        $('.wptravel-single-page-stripcheckout').css('visibility', 'hidden');
                    }
                });
    
        }, [ ])

        return <>
        <div className='wp-travel-one-page-booking-buttons' style={{ display: "none" }}>
            <span class="btn" id="wptravel-pay-with-stripe">Book Now</span>
        </div> 
        </>
    }else{

        const [ stCardError, setStCardErro ] = useState({ card : '' })
        const bookingData  = useSelect((select) => { return select(bookingStoreName).getAllStore() }, []);
        const { currency_code, currency_symbol } = bookingData;

        
        const cardErrors = document.getElementById('card-errors');
        
        if (!cardErrors) {
            const errorElement = document.createElement('div');
            errorElement.id = 'card-errors';
            errorElement.className = 'error-message';
            
            // Find the parent div and append the error message below it
            const checkoutDiv = document.querySelector('.wptravel-single-page-stripcheckout');
            if (checkoutDiv) {
                checkoutDiv.parentNode.insertBefore(errorElement, checkoutDiv.nextSibling);
            }
        }

        useEffect( () => {
    
                const stripeInit = ( form ) => {
                    // Create references to the main form and its submit button.
                    var stripe, elements, style, card, form, submitBtn, paymentIntent, cardElement, cardEl;
                    submitBtn = form.querySelector('input[type=submit]');
                    cardElement = document.createElement('div')

                    cardElement.classList.add('wp-travel-form-field', 'payment-card-field')
                    var refElement = form.querySelector('.wp-travel-form-field.button-field')
                    cardEl = refElement.parentNode.insertBefore(cardElement, refElement)

                    // Create a Stripe client.
                    stripe = Stripe(wp_travel.payment.stripe_publishable_key);
                    elements = stripe.elements();
                    style = {
                        iconStyle: 'solid',
                        style: {
                            base: {
                                iconColor: '#c4f0ff',
                                color: '#fff',
                                fontWeight: 500,
                                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',

                                ':-webkit-autofill': {
                                    color: '#fce883',
                                },
                                '::placeholder': {
                                    color: '#87BBFD',
                                },
                            },
                            invalid: {
                                iconColor: '#FFC7EE',
                                color: '#FFC7EE',
                            },
                        }
                    };

                    card = elements.create('card');

                    // Monitor change events on the Card Element to display any errors.
                    card.on('change', ({ error }) => {
                        const cardErrors = document.getElementById('card-errors');
                        
                        if (error) {
                            
                            setStCardErro( { ...stCardError, card : error.message} )
                            cardErrors.textContent = error.message;
                            cardErrors.classList.add('visible');

                        } else {
                            setStCardErro( { ...stCardError, card : ''} )
                            cardErrors.classList.remove('visible');
                        }
                        // Re-enable the Pay button.
                        $('.wp-travel-form-field.button-field').find('.wt-icon.wt-icon-spinner').remove();
                        submitBtn.disabled = false;
                    });

                    function handleServerResponse(response) {
                        if (response.error) {
                            // Show error from server on payment form
                        } else if (response.requires_action) {
                            // Use Stripe.js to handle required card action
                            stripe.handleCardAction(
                                response.payment_intent_client_secret
                            ).then(function (result) {
                                if (result.error) {
                                    // Show error in payment form
                                } else {
                                    // The card action has been handled
                                    // The PaymentIntent can be confirmed again on the server
                                    fetch(wp_travel.ajaxUrl + '?action=payment_intents', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ payment_intent_id: result.paymentIntent.id })
                                    }).then(function (confirmResult) {
                                        return confirmResult.json();
                                    }).then(handleServerResponse);
                                }
                            });
                        } else {
                            // Show success message
                            stripe.retrievePaymentIntent(response.payment_intent_client_secret)
                                .then(function (result) {
                                    if (result.error) {
                                        // Handle error here
                                    } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                        complete(result);
                                    }
                                })
                        }
                    }
                    const stripe_trigger =  (e) => {
                        
                        $('.wp-travel-form-field.button-field').find('.wt-icon.wt-icon-spinner').remove();
                        var wt_parsley = $("#wp-travel-booking").parsley()

                        if( !wt_parsley.isValid() ){
                            var gdprCheckbox = document.getElementById("wp-travel-enquiry-gdpr-msg");
                            var errorMessage = document.getElementById("gdpr-error-message");
                
                            if (!gdprCheckbox.checked) {
                                e.preventDefault(); // Prevent form submission
                                errorMessage.style.display = "block";
                            } else {
                                errorMessage.style.display = "none";
                            }
                        }

                        var l = $("#wp-travel-payment-mode option:selected").val();
                        var trpPrice = $('#onpage-trip_price').val()
                        if ( typeof l == 'undefined' ) {
                            l = 'full';
                        }
                        if ($('[name=complete_partial_payment]').length > 0) {
                            var o = $('#wp-travel-amount').val(); // Added for partial payment.
                        } else {
                            var o = "partial" == l ? wp_travel.payment.payment_amount : wp_travel.payment.trip_price;
                            if (!wt_parsley.isValid()) {
                                return wt_parsley.validate();
                            }
                        }


                            $('.wp-travel-form-field.button-field').append('<i class="wt-icon wt-icon-spin wt-icon-spinner"></i>');
                            submitBtn.disabled = true;
                            var title = $('.entry-title').html() || 'Trip Book';
                            var data = {
                                currency: wp_travel.payment.currency_code,
                                currency_symbol: wp_travel.currency_symbol,
                                total_qty: 1,
                                title: title,
                                amount: trpPrice,
                            };

                            var _data = {}
                            _data['name'] = document.querySelector('input[name^=wp_travel_fname_traveller]') ? document.querySelector('input[name^=wp_travel_fname_traveller]').value : document.querySelector('input[name=account_first_name]').value
                            _data['email'] = document.querySelector('input[name^=wp_travel_email_traveller]') ? document.querySelector('input[name^=wp_travel_email_traveller]').value : document.querySelector('input[name=account_email]').value
                            if (_data.name.length <= 0 || _data.email.length <= 0) {
                                const cardErrors = document.getElementById('card-errors');
                                cardErrors.textContent = 'Please add your name and email on account tab.';
                                cardErrors.classList.add('visible');
                                submitBtn.disabled = false;
                                $('.wp-travel-form-field.button-field').find('.wt-icon.wt-icon-spinner').remove();
                                return;
                            }
                            if (document.getElementById('wp-travel-booking')) {
                                let phone = document.querySelector('input[name^=wp_travel_phone_traveller]')
                                let city = document.querySelector('input[name=billing_city]')
                                let country = document.querySelector('input[name=wp_travel_country]')
                                let postalCode = document.querySelector('input[name=billing_postal]')
                                let line1 = document.querySelector('input[name=wp_travel_address]')
                                _data['address'] = {}
                                if (phone) {
                                    _data['phone'] = phone.value
                                }
                                if (city) {
                                    _data['address']['city'] = city.value
                                }
                                if (country) {
                                    _data['address']['country'] = country.value
                                }
                                if (postalCode) {
                                    _data['address']['postal_code'] = postalCode.value
                                }
                                if (line1) {
                                    _data['address']['line1'] = line1.value
                                }
                            }

                                stripe.createPaymentMethod('card', card, {
                                    billing_details: _data
                                }).then(function (result) {
                                    if (result.error) {
                                        // Show error in payment form
                                        $('.wp-travel-form-field.button-field').find('.wt-icon.wt-icon-spinner').remove();
                                        submitBtn.disabled = false;
                                        alert('Couldn\'t complete. Please try again later.')
                                    } else {
                                        // checking inventory enable or not. if enable then also checking max pax available or not.
                                        //since 6.6.0
                                        if ( typeof wp_travel.inventory != 'undefined' && wp_travel.inventory == 'yes' ) {
                                            fetch( wp_travel.ajaxUrl + '?action=inventory_testing'+wp_travel._nonce, {
                                                method : 'POST',
                                                headers : { 'Content-Type': 'application/json' },
                                                body : JSON.stringify({ wp_travel_trip : typeof wp_travel.items != 'undefined' && wp_travel.items || Array(), nonce :  wp_travel.nonce } )
                                            } ).then( function ( resp ) { 
                                                resp.json().then( responces => {
                                                    if ( responces.success == true ) {
                                                        if ( typeof responces.data != 'undefined' && typeof responces.data.code != 'undefined' && typeof responces.data.inventory_available != 'undefined' && responces.data.code == "WP_TRAVEL_INVENTORY_TESTING" && responces.data.inventory_available == 'no_pax' ) {
                                                            if ( confirm( "Sorry your booking can't proceed, booking is full." ) ) {
                                                                fetch( wp_travel.ajaxUrl + '?action=wp_travel_use_inventory_empty_cart'+ wp_travel._nonce, {
                                                                    method : 'POST',
                                                                    headers : { 'Content-Type' : 'application/json' },
                                                                    body : JSON.stringify( { wp_travel_empty_cart : typeof wp_travel.items != 'undefined' && wp_travel.items || Array() } ),
                                                                } ).then( results => results.json().then( resu => { location.reload();} ) ) ;
                                                            }
                                                        } else {
                                                            // Otherwise send paymentMethod.id to your server (see Step 2)
                                                            fetch(wp_travel.ajaxUrl + '?action=payment_intents', {
                                                                method: 'POST',
                                                                headers: { 'Content-Type': 'application/json' },
                                                                body: JSON.stringify({ payment_method_id: result.paymentMethod.id, data: data })
                                                            }).then(function (result) {
                                                                // Handle server response (see Step 3)
                                                                result.json().then(function (json) {
                                                                    handleServerResponse(json);
                                                                })
                                                            });
                                                        }

                                                    }
                                                })
                                                
                                            })
                                        } else {
                                            // Otherwise send paymentMethod.id to your server (see Step 2)
                                            fetch(wp_travel.ajaxUrl + '?action=payment_intents', {
                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                body: JSON.stringify({ payment_method_id: result.paymentMethod.id, data: data })
                                            }).then(function (result) {
                                                // Handle server response (see Step 3)
                                                result.json().then(function (json) {
                                                    handleServerResponse(json);
                                                })
                                            });
                                        }
                                    }
                                });
                        }

                    const complete = function (response) {
                        var form_id = 'wp-travel-booking'; // Default payment form id
                        submitBtn.disabled = false;
                        var payment_form_id = $('#wp-travel-payment-form-id').val();

                        if (payment_form_id) {
                            form_id = payment_form_id;
                        }
                        $('.loader-active').show();
                        stripe_remove();
                        setTimeout(function () {
                            $('[name=payment_details]').remove();
                            $('form#' + form_id).append($("<input type='hidden' name='payment_details' />").attr("value", JSON.stringify(response)));
                            $('form#' + form_id).find("[type=submit]").click();
                        }, 2);

                    };
                    const stripe_checkout = function () {
                        stripe_remove();

                        var payment_gateway = $('input[name=wp_travel_payment_gateway]').attr('type').match(/(radio|checkbox)/) && $('input[name=wp_travel_payment_gateway]:checked').val() || $('input[name=wp_travel_payment_gateway]').val()

                    
                        if ('stripe' === payment_gateway ) {
                            $('.wp-travel-one-page-booking-buttons').css( 'opacity', 1 );
                            $('.wp-travel-one-page-booking-buttons').css( 'pointer-events', 'auto' );
                            $('.wp-travel-one-page-booking-buttons').css( 'cursor', 'auto' );
                            $('.wptravel-single-page-stripcheckout').css( 'display', 'flex' );
                            $('.payment-card-field').show();
                            card.mount('#card-element');
                            const brandLogo = document.createElement('img')
                            brandLogo.src = _wpTravelStripeL10n.brandLogo
                            brandLogo.classList.add('stripe-brand-logo')
                            $("#wp-travel-book-now, #wp-travel-complete-partial-payment").show().siblings().hide();

                            $(".paypal-button").remove();
                            $(brandLogo).insertAfter($('#wp-travel-book-now'))
                            $('[name=wp_travel_book_now], [name=complete_partial_payment]').click(stripe_trigger);
                        } else {
        
                            $('.payment-card-field').hide();
                            $('.stripe-brand-logo').remove()
                            card.unmount();
                        }
                    }
                    const stripe_remove = function () {
                        $('[name=wp_travel_book_now]').off('click', stripe_trigger);
                        $('[name=complete_partial_payment]').off('click', stripe_trigger);
                    }

                    stripe_checkout();

                    $('#wp-travel-booking').length > 0 && $('#wp-travel-booking').parsley();
                }
                

                if ($('input[name="wp_travel_payment_gateway"]:checked').val() === 'stripe') {
                    $('.wptravel-single-page-stripcheckout').css( 'visibility', 'visible' );
                }else{
                    $('.wptravel-single-page-stripcheckout').css( 'visibility', 'hidden' );
                }

                let isStripeInitialized = false;

                $('input[name="wp_travel_payment_gateway"]').on('change', function () {
                    const selectedGateway = $('input[name="wp_travel_payment_gateway"]:checked').val();

                    if (selectedGateway === 'stripe' && !isStripeInitialized) {
                        $('.wptravel-single-page-stripcheckout').css('visibility', 'visible');

                        const form = document.getElementById('wp-travel-booking') || document.getElementById('wp-travel-partial-payment');
                        if (form && wp_travel.payment.stripe_publishable_key.length > 0) {
                            stripeInit(form); 
                            isStripeInitialized = true; // Set flag after initialization
                        }
                    } else if (selectedGateway !== 'stripe') {
                        $('.wptravel-single-page-stripcheckout').css('visibility', 'hidden');
                    }
                });
    
        }, [ ])

        return <>
        <div className='wp-travel-one-page-booking-buttons' > 
            <input type="submit" name="wp_travel_book_now" id="wp-travel-book-now" value="Book Now" /> 
        </div> 
        </>
    }
    
    
}